import React, { useEffect, useState } from 'react';
import CardContainer from 'components/Tvendo/Common/CardContainer';
import RegularButton from 'components/CustomButtons/Button';
import ReactTable from 'components/ReactTable/ReactTable';
import PromotionRetentionModal from './PromotionRetentionModal';
import { Visibility } from '@material-ui/icons';
import { wsFindBy } from 'services/WService';
import { useModal } from 'hooks/useModal';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

const states = [
  { value: 'D', text: 'Actualización solicitada' },
  { value: 'U', text: 'Actualización aprobada' },
  { value: 'X', text: 'Por aprobar' },
  { value: 'A', text: 'Aprobado' },
  { value: 'C', text: 'Anulado' },
];

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 125 },
  { Header: 'Id', accessor: 'promotion_id', width: 120 },
  { Header: 'Estado', accessor: 'state', width: 120 },
  { Header: 'Promoción', accessor: 'promotion_description', width: 350 },
  { Header: 'Comentario', accessor: 'comment', width: 150 },
  { Header: 'Fecha Creación', accessor: 'created_at', width: 150 },
  { Header: 'Creado por', accessor: 'createdBy', width: 150 },
  { Header: 'Aprobado por', accessor: 'approvedBy', width: 150 },
];

function PromotionRetentionList() {
  const [retainedPromotions, setRetainedPromotions] = useState([]);
  const [model, setOpen] = useModal();
  const [dataLoading, setDataLoading] = useState(false);

  async function listRetentions() {
    setDataLoading(true);
    setRetainedPromotions([]);
    let res = await wsFindBy('prom/retention');
    setDataLoading(false);
    if (res.success) {
      setRetainedPromotions(res.data);
    }
  }

  useEffect(() => {
    listRetentions();
  }, []);

  return (
    <CardContainer /*title="Promociones retenidas"*/ title={(<>Promociones retenidas {dataLoading && <LoadingSpinner />}</>)}>
      <PromotionRetentionModal model={model} setOpen={setOpen} refreshRetentions={listRetentions} />
      <ReactTable
        columns={columns}
        defaultWidth={1350}
        data={retainedPromotions.map((item, i) => {
          let state = '';
          state = states.find((state) => state.value === item.state)?.text || item.state;
          return {
            num: (
              <>
                {i + 1}
                <RegularButton
                  justIcon
                  round
                  simple
                  color="primary"
                  onClick={(e) => {
                    setOpen(item);
                  }}
                >
                  <Visibility />
                </RegularButton>
              </>
            ),
            promotion_id: item.prom_promotion_id,
            state,
            promotion_description: item.promotion.description,
            comment: item.comment || '-',
            created_at: item.created_at,
            createdBy: item.created_by?.name || '-',
            approvedBy: item.approved_by?.name || '-',
          };
        })}
      />
    </CardContainer>
  );
}

export default PromotionRetentionList;
